import { lazy, Suspense } from 'react';

import IncidentDetails from '@/components/Incidents/incident-details';
import StationDetailsLoader from '@/components/shared/loader/station-details-loader';
import StationIncidentsList from '@/components/stations/station-incidents-list';
import StationList from '@/components/stations/station-list';
import { INCIDENT_DETAILS, INCIDENTS_LIST, MONITOR, STATION_DETAILS } from '@/utils/constants';

const LazyMonitorDetails = lazy(() => import('@/components/monitor-details'));
const LazyStationDetails = lazy(() => import('@/components/station-details'));

interface StationsRendererProps {
  viewType: string;
  passengerMonitorLink?: string;
  rhbMonitorLink?: string;
  onStationDetailsError: (value: boolean) => void;
  onStationDetailsLoading: (value: boolean) => void;
  selectedTab: string;
  onTabSelect: (tab: string) => void;
  currentStationId: string | null;
}

const StationContentRenderer = ({
  viewType,
  passengerMonitorLink,
  rhbMonitorLink,
  onStationDetailsError,
  onStationDetailsLoading,
  selectedTab,
  onTabSelect,
  currentStationId,
}: StationsRendererProps) => {
  if (viewType === INCIDENTS_LIST && currentStationId) {
    return <StationIncidentsList stationId={currentStationId} />;
  }

  if (viewType === INCIDENT_DETAILS) {
    return <IncidentDetails />;
  }

  if (viewType === MONITOR) {
    return (
      <LazyMonitorDetails
        passengerMonitorLink={passengerMonitorLink}
        rhbMonitorLink={rhbMonitorLink}
      />
    );
  }

  if (viewType === STATION_DETAILS) {
    return (
      <Suspense fallback={<StationDetailsLoader departureCount={10} />}>
        <LazyStationDetails
          handleErrorChange={onStationDetailsError}
          onToggleLoading={onStationDetailsLoading}
          selectedTab={selectedTab}
          onTabSelect={onTabSelect}
        />
      </Suspense>
    );
  }

  return <StationList />;
};

export default StationContentRenderer;
